const fetch = require('cross-fetch');
const { stringify } = require('querystringify');
const { getApiLanguage } = require('./language');
const { handleResponse, LootBoyApiError } = require('./util');
const { stripUndefined } = require('../utils');

const api = module.exports;

exports.onCaptchaRequired = () => {};
exports.onBeingBlocked = () => {};
exports.onSuccessfulRequest = () => {};
exports.legitimateToken = '';
exports.signature = '';

const fetchJsonApi = async ({
  apiUrl,
  method,
  endpoint,
  expectedStatus,
  body,
  headers = {},
  description,
  query = {},
  skipHumanVerification,
}) => {
  const requestHeader = {
    Accept: 'application/json',
    'Accept-Language': getApiLanguage(),
    'Content-Type': 'application/json',
    ...headers,
  };

  if (api.legitimateToken && api.signature && !skipHumanVerification) {
    requestHeader['X-API-Token'] = api.legitimateToken;
    requestHeader['X-API-Sign'] = api.signature;
  }

  const queryString =
    typeof query === 'string' ? query : stringify(stripUndefined(query), false);

  // this is necessary for uploads, null value cause browser to generate this header
  if (requestHeader['Content-Type'] === null) {
    delete requestHeader['Content-Type'];
  }

  const url = `${apiUrl}/${endpoint}${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(url, {
    method,
    headers: requestHeader,
    body: body && (body instanceof FormData ? body : JSON.stringify(body)),
  });

  try {
    const handledResponse = await handleResponse(
      response,
      expectedStatus,
      description,
    );

    if (!skipHumanVerification) {
      api.legitimateToken = '';
      api.signature = '';
      if (typeof api.onSuccessfulRequest === 'function') {
        const callback = api.onSuccessfulRequest;
        api.onSuccessfulRequest = null;
        callback();
      }
    }

    return handledResponse;
  } catch (e) {
    if (e instanceof LootBoyApiError && e.status === 403) {
      if (e.messageId === 'blocked') {
        if (typeof api.onBeingBlocked === 'function') {
          const callback = api.onBeingBlocked;
          api.onBeingBlocked = null;
          callback();
        }
      } else if (e.messageId === 'captcha_required') {
        if (typeof api.onCaptchaRequired === 'function') {
          const callback = api.onCaptchaRequired;
          api.onCaptchaRequired = null;
          callback();
        }
      }
    }
    throw e;
  }
};

const fetchAuthorizedJsonApi = async ({
  apiUrl,
  token,
  method,
  endpoint,
  expectedStatus,
  body,
  headers = {},
  description,
  query = {},
}) =>
  fetchJsonApi({
    apiUrl,
    method,
    endpoint,
    expectedStatus,
    body,
    headers: {
      ...(headers || {}),
      Authorization: `Bearer ${token}`,
    },
    description,
    query,
  });

const fetchAuthorizedUploadJsonApi = async ({
  apiUrl,
  token,
  method,
  endpoint,
  expectedStatus,
  body = {},
  files,
  headers = {},
  description,
  query = {},
}) => {
  const data = new FormData();
  Object.keys(body).forEach((key) => {
    data.append(key, JSON.stringify(body[key]));
  });
  Object.keys(files).forEach((file) => data.append(file, files[file]));
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method,
    endpoint,
    expectedStatus,
    body: data,
    headers: {
      ...headers,
      'Content-Type': null,
    },
    description,
    query,
  });
};

exports.fetchJsonApi = fetchJsonApi;
exports.fetchAuthorizedJsonApi = fetchAuthorizedJsonApi;
exports.fetchAuthorizedUploadJsonApi = fetchAuthorizedUploadJsonApi;
exports.setOnCaptchaRequired = (callback) => {
  api.onCaptchaRequired = callback;
};
exports.setOnBeingBlocked = (callback) => {
  api.onBeingBlocked = callback;
};
exports.setOnSuccessfulRequest = (callback) => {
  api.onSuccessfulRequest = callback;
};
exports.setLegitimateToken = (legitimateToken) => {
  api.legitimateToken = legitimateToken || '';
};
exports.setSignature = (signature) => {
  api.signature = signature || '';
};
